import { Link } from 'react-router-dom';
import { AlertTriangle, Check, X, XCircle } from 'lucide-react';
import { useAlerts } from '../lib/alerts';

/** On-screen alerts (top right). FAIL alerts stay until acknowledged or dismissed. */
export function AlertToasts() {
  const { toasts, dismiss, acknowledge } = useAlerts();
  if (toasts.length === 0) return null;
  return (
    <div className="toasts" role="region" aria-label="Alerts" aria-live="assertive">
      {toasts.map((a) => (
        <div key={a.id} className={`toast toast-${a.severity === 'FAIL' ? 'fail' : 'warn'}`}>
          {a.severity === 'FAIL' ? <XCircle size={18} aria-hidden /> : <AlertTriangle size={18} aria-hidden />}
          <div className="toast-body">
            <Link to={`/streams/${a.streamId}`} className="toast-title">
              {a.severity === 'FAIL' ? 'FAIL' : 'WARNING'}: {a.streamName}
            </Link>
            <p>{a.message}</p>
            <span className="muted small">{new Date(a.at).toLocaleTimeString('en-GB', { hour12: false })}</span>
          </div>
          <div className="toast-actions">
            <button type="button" className="btn btn-sm btn-ghost btn-icon" aria-label="Acknowledge" title="Acknowledge" onClick={() => void acknowledge([a.id])}>
              <Check size={16} aria-hidden />
            </button>
            <button type="button" className="btn btn-sm btn-ghost btn-icon" aria-label="Dismiss" title="Dismiss" onClick={() => dismiss(a.id)}>
              <X size={16} aria-hidden />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
